import { Navigate } from "react-router-dom";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import { EmailEventsPage as EmailEventsPageComponent } from "@/modules/email-events";
import useUserStore from "@/modules/users/store";
import { ID_CONFIGURACAO_EVENTOS_EMAIL } from "@/utils/constants";

/**
 * Email Events Page Route Wrapper
 *
 * Integrates EmailEventsPage with the routing system.
 * Provides licenciadaId from the user store.
 */
export default function EmailEventsPage() {
  const { read: hasReadPermission } = useGetAuthorizations(ID_CONFIGURACAO_EVENTOS_EMAIL);
  const activeLicenciadaId = useUserStore((state) => state.activeLicenciadaId);
  const licenciadaId = activeLicenciadaId || "";

  if (!hasReadPermission) {
    return <Navigate to="/" replace />;
  }

  if (!licenciadaId) {
    return null;
  }

  return <EmailEventsPageComponent licenciadaId={licenciadaId} />;
}
